import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loginWithProvider } from '../../actions/firebase_actions';

class UserRegister extends Component {
    constructor(props) {
        super(props);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.state = {
            message: '',
        };
    }

    loginWithProvider(provider) {
        this.props.loginWithProvider(provider).then(data => {
            if (data.payload.errorCode) {
                this.setState({ message: data.payload.errorMessage });
            }
            else {
                browserHistory.push('/checkin');
            }
        });
        // alert("login with provider");
    }

    onFormSubmit(event) {
        event.preventDefault();

        const email = this.refs.email.value;
        const password = this.refs.password.value;
        this.props.registerUser({ email, password }).then((data) => {
            if (data.payload.errorCode) {
                this.setState({ message: data.payload.errorMessage });
            }
            else {
                browserHistory.push('/profile');
            }
        });
    }

    render() {
        let errorMessage = null;

        if (this.state.message != null && this.state.message !== '') {
            errorMessage = (
                <div className="alert alert-warning" role="alert">
                    { this.state.message }
                </div>
            );
        }

        return (
            <div className="container jumbotron-container vertical-center">
                <div className="card horizontal-center"  style={ { maxWidth: '600px' } }>
                    <div className="card-block text-xs-center">
                        <h2 className="card-title">Welcome!</h2>

                        <hr className="hr-depth" />

                        <p className="text-muted-inverse">
                            You're making an excellent decision. You're only one step away from joining an amazing community of fellow travelers.
                        </p>

                        <form id="frmRegister" role="form" onSubmit={ this.onFormSubmit } className="container">
                            { errorMessage }

                            <a href="#" className="btn btn-classy" onClick={() => {
                                this.loginWithProvider("facebook")
                            } } data-provider="facebook" style={ { width: '50%', minWidth: '260px' } }>
                                <i className="fa fa-facebook"></i>
                                Sign up with Facebook
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loginWithProvider,
    }, dispatch);
}

function mapStateToProps(state) {
    return { currentUser: state.currentUser };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRegister);



// WEBPACK FOOTER //
// ./src/app/components/user/register.jsx